import { userFullName } from "helpers/common";
import { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useCreateNoteMutation, useDeleteNoteMutation, useGetNoteQuery, useUpdateNoteMutation } from "store/services/note";
import LoadingOverlay from "../LoadingOverlay";
import moment from "moment";
import p1 from "../../../Assets/images/user.png";
import imageLoader from '../../../Assets/images/imageLoader.gif'
import { useSelector } from "react-redux";
import ViewAllNotes from "components/Modals/ViewAllNotesPop";
import { NoRecordFound } from "components/Common/Common";

const singleNote = { note: "", disable: false };

const NotesComponent = ({ client_id, module, heading = "Notes", buttonName = "Create Note" }) => {
  const [showAllNotes, setShowAllNotes] = useState(false);

  // notes
  const { data: notes, isLoading, isFetching } = useGetNoteQuery({ clientId: client_id, moduleName: module }, { skip: !client_id });
  const [isCreate, setIsCreate] = useState(false);
  const notesArray = notes?.length ? notes?.map(i => ({ ...i, disable: true })).sort((a, b) => a.pin_top == "Y" ? -1 : 1) : [{ ...singleNote }];
  const noteToShow = notes?.find(x => x?.pin_top == "Y") || notes?.find(x => x?.id);

  return (
    <div className="w-100">
      {(isLoading || isFetching) && <LoadingOverlay />}
      <ViewAllNotes
        isCreate={isCreate}
        show={showAllNotes}
        setShow={setShowAllNotes}
        notes={notesArray}
        client_id={client_id}
        module={module}
      />
      <Row className="align-items-center my-3" >
        <Col lg="12" >
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="m-0 themeBlue fw-semibold">{heading}</h6>
            <Button
              className="commonBtn"
              style={{ padding: "0", height: "35px", minWidth: "100px" }}
              onClick={() => { setIsCreate(true); setShowAllNotes(true) }}

            >{buttonName}</Button>
          </div>
        </Col>
        <Col lg="12">
          <Row>
            {noteToShow ? <Col lg="12" sm="12">
              <div className="student-details-main-box p-3 rounded shadow" style={{ background: "rgb(253 217 202 / 31%)", border: "1px solid rgb(61, 160, 170)" }}>
                <div className="student-details-main-box-inner">
                  <div className="student-details-main-box-heading"
                  >
                  </div>
                </div>
                <p style={{ fontSize: "14px", fontWeight: "700", textTransform: "capitalize" }}>{noteToShow?.note}</p>

                <div className="student-details-main-notes" style={{ fontSize: "12px" }}>
                  <div className="student-details-inner-notes d-flex align-items-center gap-2">
                    <img
                      src={noteToShow?.noteOwner?.therapist_detail?.profile_picture === null ? p1 : (noteToShow?.noteOwner?.therapist_detail?.profile_picture == "undefined" ? imageLoader : noteToShow?.noteOwner?.therapist_detail?.profile_picture ? noteToShow?.noteOwner?.therapist_detail?.profile_picture : p1 )}
                      // src={noteToShow?.noteOwner?.therapist_detail?.profile_picture || p1}
                      alt=""
                      className="img-fluid object-fit-cover rounded-circle border border-white"
                      style={{ height: 30, width: 30 }}
                    />
                    {userFullName(noteToShow?.noteOwner)}
                  </div>
                  <div className="student-details-inner-notes">
                    {moment(noteToShow?.createdAt).format("DD/MM/YYYY")}
                  </div>
                </div>
              </div>
            </Col> : <div className="px-2"><NoRecordFound showBorder /></div>}
            <Col lg="12" sm="12" className="mt-2">
              <div className="w-100 d-flex justify-content-end">
                <p
                  style={{ color: "#b46c9f", fontSize: "14px", cursor: "pointer" }}
                  onClick={() => { setIsCreate(false); setShowAllNotes(true) }}
                >
                  {"Show all"}
                </p>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div >
  );

};

export default NotesComponent;